import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const RTL_LANGUAGES = ['ar'];

/**
 * Keeps document direction and lang attribute in sync with the active i18next
 * language. Detection itself is fully owned by i18next (querystring `?lng=`,
 * cookie, localStorage, navigator — see src/utils/i18n.ts) plus the IP-based
 * override in src/utils/geolocation.ts; this hook must not re-detect or it
 * fights those sources.
 */
export function useLanguageDetection(): void {
  const { i18n } = useTranslation();

  useEffect(() => {
    const apply = (lng: string) => {
      document.documentElement.dir = RTL_LANGUAGES.some((l) => lng.startsWith(l)) ? 'rtl' : 'ltr';
      document.documentElement.lang = lng;
    };
    apply(i18n.language);
    i18n.on('languageChanged', apply);
    return () => {
      i18n.off('languageChanged', apply);
    };
  }, [i18n]);
}
